import React from 'react';
import ReactSelect from 'react-select';

const MultiSelect = (props) => <ReactSelect {...props} isMulti />;

export class MultiSelectOption {
  constructor(value, label = value) {
    this.label = label;
    this.value = value;
  }
}

export default MultiSelect;
